import { getGoogleMapsSearchLink } from '@apps/guest/packages/layout-engine/common/utils/getGoogleMapsSearchLink';
import { ScheduleItemProps } from '../ScheduleDisplay';
import { AddToCalendarProps } from '@shared/components/AddToCalendar';
import { split86012String } from '@shared/components/ScheduleEditor/components/form/hooks/useGetEventTimezone';

export const goToAccommodations = () => {
  window?.open('./accommodations', '_self');
};

export const goToDirections = (location: string) => {
  window?.open(getGoogleMapsSearchLink(location), '_blank', 'noopener,noreferrer');
};

export const getCalendarProps = (item: ScheduleItemProps['data']): Omit<AddToCalendarProps, 'children'> => {
  const startDate = item.startTimeISO8601TZ ? split86012String(item.startTimeISO8601TZ) : undefined;
  const endDate = item.endTimeISO8601TZ ? split86012String(item.endTimeISO8601TZ) : undefined;

  return {
    // Can never be null. But TS does not know that.
    start: startDate?.datetime.toISOString() ?? new Date().toISOString(),
    end: endDate?.datetime.toISOString() ?? undefined,
    title: item.name,
    description: item.description ?? undefined,
    location: item.location ?? undefined,
  };
};
